import { theBigBashLogoAnimationSvg2 } from "@/assets/images/svgFiles";
import { sharedStyles } from "@lib/sharedStyles";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("not-found-page")
export class NotFoundPage extends LitElement {
	static override styles = [
		sharedStyles,
		css`
      .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2rem;
      }

      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
        max-width: 400px;
        height: auto;
      }

      .buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;
      }

      basic-button {
        min-width: 160px;
        text-align: center;
      }
    `,
	];

	private navigate(path: string) {
		window.history.pushState({}, "", path);
		window.dispatchEvent(new PopStateEvent("popstate"));
	}

	render() {
		return html`
      <div class="container">
		<h1>404</h1>
        <div class="logo">${theBigBashLogoAnimationSvg2}</div>
        <div class="buttons">
          <basic-button @click=${() => this.navigate("/room/skills")}
            >Room Skills</basic-button
          >
          <basic-button @click=${() => this.navigate("/room/action")}
            >Room Action</basic-button
          >
          <basic-button @click=${() => this.navigate("/room/brain")}
            >Room Brain</basic-button
          >
          <basic-button @click=${() => this.navigate("/host/events")}
            >Moderator</basic-button
          >
        </div>
      </div>
    `;
	}
}

export default NotFoundPage;
